import { api } from "../../services";
import { $config } from "../../conf";

export let captchaAPI = {
  /**
   * 发送短信验证码
   * @param {String} mobile 手机号
   * @param {String} scenesKey 场景key:长度大于10的随机值。校验时需要再次传送
   * @returns {*}
   */
  onSmsCaptchaSend({ mobile, scenesKey }) {
    return api.request("/api/sms/captcha/send", {
      tenantId: $config.tenantId,
      mobile,
      scenesKey,
    });
  },

  /**
   * 验证码验证
   * @param unique 邮箱或手机号
   * @param scenesKey 场景key:长度大于10的随机值。调用发送接口时的相同数值
   * @param code 验证码
   * @returns {*}
   */
  onCaptchaVerify({ unique, scenesKey, code }) {
    return api.request("/api/captcha/verify", {
      unique,
      scenesKey,
      code,
    });
  },
};
